import React from 'react'


export const MainContext = React.createContext(null)
export const ChooseContext = React.createContext(null)